import { X } from 'lucide-react';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { FileSize } from 'ud-form/components/file-size';
import UDText from 'ud-ui/components/text';
import { DropzonePreview } from '../domain/previews';
import { FileName, PreviewCard, REMOVE_BUTTON_CLASS, RemoveButton, Thumb } from './styles';

export interface PreviewItemProps {
  preview: DropzonePreview;
  size: number;
  showFileName?: boolean;
  onRemove?: () => void;
  onOpen?: () => void;
}

/**
 * Одна выбранная картинка: миниатюра, её имя и вес.
 *
 * Вес показывается только у файла, выбранного сейчас, — у картинки, которая уже
 * лежит на бэкенде, в поле один адрес, и взять вес неоткуда. Решает это сам
 * `FileSize`, поэтому здесь никаких условий нет.
 */
export function PreviewItem({ preview, size, showFileName, onRemove, onOpen }: PreviewItemProps) {
  return (
    <PreviewCard>
      {onRemove && (
        <RemoveButton
          type="button"
          className={REMOVE_BUTTON_CLASS}
          aria-label={`Удалить изображение${preview.name ? ` ${preview.name}` : ''}`}
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
        >
          <X size={16} />
        </RemoveButton>
      )}

      <Thumb
        size={size}
        onClick={(event) => {
          // Превью под зоной живёт вне кликабельной области, а внутри зоны —
          // внутри неё: без остановки клик открыл бы ещё и выбор файла.
          event.stopPropagation();
          onOpen?.();
        }}
        style={{ cursor: onOpen ? 'pointer' : 'default' }}
      >
        <img src={preview.url ?? USER_DEFAULT_AVATAR} alt={preview.name ?? 'Изображение'} />
      </Thumb>

      {showFileName && preview.name && (
        <UDText type="subhead" style={{ maxWidth: '100%' }}>
          <FileName>{preview.name}</FileName>
        </UDText>
      )}

      <FileSize value={preview.size} />
    </PreviewCard>
  );
}
